import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from "../componentes/header/header";
import Footer from "../componentes/footer/footer";
import { assets } from "../assets/assets";
import './conserto_relogio.css'; // Reutilizando o CSS para manter o padrão
import { abrirOrcamentoWhats, trazerRodapePaginasServicos, trazerTituloServicos } from '../utils/utils';

const ReparoOculos = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Trinco | Serviços de óculos";
  }, []);

  return (
    <div className="servico-detalhe-page">
      <Header />

      {/* Hero Banner */}
      <section className="servico-hero" style={{ backgroundImage: `url(${assets.reparoOculos})` }}>
        <div className="servico-hero-overlay">
          <h1>Serviços de Óculos</h1>
          <p>Para quem não pode ficar sem eles.</p>
        </div>
      </section>

      {/* Conteúdo Explicativo */}
      <main className="conteudo-servico-container">

        <article className="bloco-texto">
          <h2>{trazerTituloServicos('óculos')}</h2>
        </article>

        {/* Bloco 1: Molas e Parafusos */}
        <section className="sessao-explicativa">
          <div className="texto-lado">
            <h3>Ajuste</h3>

            <h4>Troca de molas</h4>
            <p>Correção das hastes.</p>

            <h4>Parafusos</h4>
            <p>Substituição dos parafusos da armação.</p>
          </div>
          <div className="imagem-lado">
            <img src={assets.trocaMolasParafusosOculos} alt="Troca de molas e parafusos em óculos" />
          </div>
        </section>

        {/* Bloco 2: Soldas e Cravejamento */}
        <section className="sessao-explicativa reverse">
          <div className="texto-lado">
            <h3>Restauração</h3>

            <h4>Solda</h4>
            <p>Correção da armação para restaurar a estrutura da peça.</p>

            <h4>Cravejamento</h4>
            <p>Reposição de pedrinhas e detalhes da armação.</p>
          </div>
          <div className="imagem-lado">
            <img src={assets.soldaCravejamentoOculos} alt="Solda e cravejamento de óculos" />
          </div>
        </section>

        {/* Bloco 3: Manutenção Geral e Limpeza (Genérico para complementar) */}
        <section className="sessao-explicativa">
          <div className="texto-lado">
            <h3>Alinhamento</h3>

            <h4>Desempeno</h4>
            <p>Correção de armações tortas.</p>
          </div>
          <div className="imagem-lado">
            <img src={assets.manutencaoOculos} alt="Manutenção e limpeza de óculos" />
          </div>
        </section>

        <div className="fechamento-texto">
          <h4>{trazerRodapePaginasServicos('serviços de óculos')}</h4>
        </div>

        {/* CTA FINAL */}
        <div className="cta-container-detalhe">
          <button className="btn-orcamento-whats" onClick={() => abrirOrcamentoWhats('serviços de óculos')}>
            Solicitar orçamento
          </button>
          <button className="btn-voltar-simples" onClick={() => navigate('/')}>
            Voltar para o início
          </button>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default ReparoOculos;